import {register} from '@shopify/theme-sections';

export default register('instagram-feed', {
  onLoad() {
    /**
     * By default the Instagram feed is hidden, once foursixty loads we check
     * if it is hidden and if it's not we show the whole section.
     * Due to some lag time in FourSixty initialising itself we run the check
     * twice before setting our final value.
     */

    let foundContainer = false;

    const $instagramFeed = this.container;
    const instagramCheck = setInterval(handleInstagramFeedCheck, 500);

    function handleInstagramFeedCheck() {
      const $fsSliderContainer = $instagramFeed.querySelector('.fs-slider-container');

      if (!$fsSliderContainer) {
        return;
      }

      if (!foundContainer) {
        foundContainer = true;
        return;
      }

      if (window.getComputedStyle($fsSliderContainer).display !== 'none') {
        $instagramFeed.classList.remove('hide');
      }

      clearInterval(instagramCheck);
    }
  },
});
